<template>
  <div class="v-mosaic">
    <div class="v-mosaic-header d-flex">
      <slot name="header"></slot>
    </div>

    <div class="v-mosaic-body" style="background-color: #A0A3BD">
      <slot name="body"></slot>
    </div>

    <div class="v-mosaic-toolbar">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>

export default {
  name: 'VMosaic',
};
</script>

<style lang="scss">
@import "VMosaic";
</style>

